import { noop } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import * as v from "valibot"

import { query } from "@/api/query"
import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { $rqStorageTemplatesApiClient } from "@/api/storage"
import { getXOrganizationHeaders } from "@/api/utils"
import { MY_SPACE } from "@/constants/spaces"
import { routeGuard } from "@/lib/routing/beforeLoad"

const searchSchema = v.object({
  tab: v.optional(v.union([v.literal("custom"), v.literal("arduino")])),
  folderId: v.optional(v.string())
})

export const Route = createFileRoute("/_authlayout/_sidebar/templates/")({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ tab: search.tab }),
  beforeLoad: async ({ context, search, location }) => {
    const { queryClient, spaceStorage } = context
    const spaces = await queryClient.query({ ...query.space.list, staleTime: "static" })
    const { space } = spaces.find(sp => sp.id === spaceStorage.getSpace()) || MY_SPACE

    if (!search.tab) {
      redirect({
        to: location.pathname,
        throw: true,
        search: {
          tab: space === "pro" ? "custom" : "arduino"
        }
      })
    }
    await routeGuard(context, { permission: { flag: "iot:template::read" } })
  },
  loader: ({ context: { queryClient, spaceStorage }, deps }) => {
    const space = spaceStorage.getSpace()

    if (deps.tab === "arduino") {
      queryClient.query(query["iot-templates"].list).catch(noop)
    }

    if (deps.tab === "custom") {
      queryClient
        .query(
          $rqStorageTemplatesApiClient.queryOptions("post", "/storage/template/v1/list", {
            params: { header: getXOrganizationHeaders(space) },
            body: { sort: "asc", show_deleted: false }
          })
        )
        .catch(noop)
      queryClient.query(query.space.members(space)).catch(noop)
      queryClient.query(getBoardsQueryOptions()).catch(noop)
    }
  },
  head: () => ({
    meta: [
      {
        title: "Templates | Arduino Cloud"
      }
    ]
  })
})
